import { render, staticRenderFns } from "./AddressReview.vue?vue&type=template&id=554f426f"
import script from "./AddressReview.vue?vue&type=script&lang=js"
export * from "./AddressReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AddressReview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554f426f')) {
      api.createRecord('554f426f', component.options)
    } else {
      api.reload('554f426f', component.options)
    }
    module.hot.accept("./AddressReview.vue?vue&type=template&id=554f426f", function () {
      api.rerender('554f426f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/review/AddressReview.vue"
export default component.exports